import React, { useEffect, useState } from "react";
import { Sparkle } from "@phosphor-icons/react";
import { api, BACKEND_URL } from "../lib/api";

export const Offers = () => {
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    api.get("/offers").then((res) => setOffers(res.data || [])).catch(() => {});
  }, []);

  if (offers.length === 0) return null;

  return (
    <section className="border-y border-white/10 bg-[#0d0d0d]" data-testid="offers-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-20">
        <div className="mb-10 text-center">
          <div className="overline text-[#F5A623] mb-3 flex items-center justify-center gap-2">
            <Sparkle size={16} weight="fill" /> Solo por tiempo limitado
          </div>
          <h2 className="font-display text-5xl md:text-6xl leading-none">Ofertas y Especiales</h2>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            Nuestras promociones del momento. ¡Aprovéchalas antes de que se acaben!
          </p>
        </div>

        <div className={`grid gap-6 justify-center ${offers.length === 1 ? "grid-cols-1 max-w-md mx-auto" : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"}`}>
          {offers.map((o) => (
            <div
              key={o.id}
              className="bg-[#141414] border border-white/10 overflow-hidden group"
              data-testid={`offer-${o.id}`}
            >
              <img
                src={`${BACKEND_URL}${o.image_url}`}
                alt={o.title || "Oferta especial Ciudad Garaje"}
                loading="lazy"
                className="w-full h-auto object-contain"
              />
              {o.title && (
                <div className="p-4 text-center">
                  <span className="font-display text-2xl text-[#D97736]">{o.title}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
